import React from "react";
import { Box, IconButton, Typography } from "@mui/joy";
import cross from "../../../assets/svgs/cross.svg";

interface ModalHeaderProps {
  onClose: () => void;
  title: string;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({ onClose, title }) => {
  return (
    <>
      <Box
        width="100%"
        display="flex"
        justifyContent="end"
        alignItems="center"
        mr={4}
      >
        <IconButton onClick={onClose} variant="plain" size="sm">
          <img
            src={cross}
            alt="cross"
            style={{
              width: 20,
              height: 20,
              marginRight: 12,
              marginTop: 10,
            }}
          />
        </IconButton>
      </Box>
      <Box width="100%" display="flex" justifyContent="start" alignItems="start" px={2}>
        <Typography level="modalHeading">{title}</Typography>
      </Box>
    </>
  );
};

export default ModalHeader;
